// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lite-compare-controls{display:flex;align-items:center;justify-content:center}.lite-compare-controls__arrow{fill:var(--4lb15h);cursor:pointer}.lite-compare-controls__arrow.is-next{transform:rotate(-180deg)}.lite-compare-controls__number{font-weight:600;font-size:12px;line-height:16px;color:var(--1h79dlb);margin:0 20px}", ""]);
// Exports
module.exports = exports;
